import React, {Component} from 'react'
import {Bar} from 'react-chartjs-2'
import * as PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import MuiTable from "../common/MuiTable";
import {NotificationManager} from "react-notifications";
import {organisationDetails, saveOrUpdateOrganisationDetails} from "../../util/ApiUtils";
import { t } from '../../i18n';
import * as CommonUtils from "../../util/CommonUtils";

const months = { 1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec' };

function createChartData() {
    return {
        labels: [],
        datasets: [
            {
                label: t('leadership.correctiveActions.label'),
                backgroundColor: '#1a73e8',
                borderColor: '#1a73e8',
                borderWidth: 1,
                hoverBackgroundColor: '#1a73e8',
                hoverBorderColor: '#d93025',
                data: []
            },
            {
                label: t('leadership.nonconformanceActions.label'),
                backgroundColor: '#d93025',
                borderColor: '#d93025',
                borderWidth: 1,
                hoverBackgroundColor: '#d93025',
                hoverBorderColor: '#1a73e8',
                data: []
            }
        ]
    };
}

const options = {
    scales: {
        yAxes: [{
            scaleLabel: {
                display: true,
                labelString: 'No of Actions'
            },
            ticks: {
                min: 0
            }
        }],
        xAxes: [{
            scaleLabel: {
                display: true,
                labelString: 'Date'
            }
        }],
    }
}

const muiColumns = [
    {
        title: t('context.common.id'),
        field: 'id',
        type: "numeric",
        hidden: true,
    },
    { title: t('leadership.correctiveActions.columns.month'), field: 'month', lookup: { 'Jan': t('months.Jan'), 'Feb': t('months.Feb'), 'Mar': t('months.Mar'), 'Apr': t('months.Apr'), 'May': t('months.May'), 'Jun': t('months.Jun'), 'Jul': t('months.Jul'), 'Aug': t('months.Aug'), 'Sep': t('months.Sep'), 'Oct': t('months.Oct'), 'Nov': t('months.Nov'), 'Dec': t('months.Dec') }},
    { title: t('leadership.correctiveActions.columns.year'), field: 'year'},
    { title: t('leadership.correctiveActions.columns.corrActions'), field: 'corrActions', headerStyle: { width: "25%" } },
    { title: t('leadership.correctiveActions.columns.nonconfActions'), field: 'nonconfActions', headerStyle: { width: "25%" } },
];

class CorrectiveActions extends Component {

    constructor(props) {
        super(props);
        this.state = {
            organisation: { actions: [] },
            orgId: null,
            actions: [],
            chartData: createChartData(),
            isLoading: true
        };

        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
        this.isValid = this.isValid.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log('organisation response corrective actions', response);
                let organisation = response || {};
                let sorted = (organisation.actions || []).slice().sort(function(a, b) {
                    let am = Object.keys(months).find(key => months[key] === a.month)
                    let bm = Object.keys(months).find(key => months[key] === b.month)
                    return a.year - b.year || am - bm;
                });
                console.log('sorted actions', sorted);
                let chartData = createChartData();
                sorted.forEach((element) => {
                    chartData.labels.push(element.month + ' ' + element.year)
                    chartData.datasets[0].data.push(element.corrActions)
                    chartData.datasets[1].data.push(element.nonconfActions)
                })
                this.setState({
                    organisation: Object.assign({}, organisation, { actions: sorted }),
                    orgId: organisation.id,
                    actions: sorted,
                    chartData: chartData,
                    isLoading: false
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    isValid(newData) {
        let isValid = newData.month && newData.month !== '' && newData.year
            && newData.year !== '' && newData.corrActions && newData.corrActions !== ''
            && newData.nonconfActions && newData.nonconfActions !== '';
        if (!isValid) {
            NotificationManager.error(t('app.notifications.error'), t('messages.validationErrorFields'), 5000);
        }
        return isValid;
    }

    handleUpdate(toUpdate) {
        console.log("updating to ", toUpdate);
        for (let i = 0, l = this.state.organisation.actions.length; i < l; i++) {
            if (this.state.organisation.actions[i].id === toUpdate.id) {
                this.state.organisation.actions[i].month = toUpdate.month;
                this.state.organisation.actions[i].year = toUpdate.year;
                this.state.organisation.actions[i].corrActions = toUpdate.corrActions;
                this.state.organisation.actions[i].nonconfActions = toUpdate.nonconfActions;
            }
        }
        console.log("After update:", this.state.organisation.actions);
        this.handleSubmit(this.state.organisation.actions);
    }

    handleDelete(toDelete) {
        let actions = [];
        const index = this.state.organisation.actions.findIndex(x => x.id === toDelete.id);
        for (let i = 0, l = this.state.organisation.actions.length; i < l; i++) {
            if (i !== index) {
                actions.push(this.state.organisation.actions[i]);
            }
        }
        console.log("After removal:", actions);
        this.handleSubmit(actions);
    }

    handleAdd(data) {
        this.state.organisation.actions.push(data);
        this.handleSubmit(this.state.organisation.actions);
    }

    handleSubmit(data) {
        this.state.organisation.actions = data;
        saveOrUpdateOrganisationDetails(this.state.organisation)
            .then(() => {
                NotificationManager.success(t('app.notifications.success'), t('messages.dataUpdated'), 5000);
                this.loadOrganisationDetails();
                this.props.onChanged(this.state.organisation.actions);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    render() {
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        if (this.state.isLoading) {
            return null;
        }
        return (
            // A react-chart hyper-responsively and continuously fills the available
            // space of its parent element automatically
            <div>
                {this.props.isEdit ?
                    <React.Fragment>
                        <Paper style={{ marginTop: '30px' }}>
                            <MuiTable
                                title={ t('leadership.correctiveActions.title') }
                                columns={muiColumns}
                                data={this.state.actions}
                                onAdd={this.handleAdd}
                                onUpdate={this.handleUpdate}
                                onDelete={this.handleDelete}
                                isValid={this.isValid}
                                exportButton={false}
                                search={false}
                                pageSize={20}
                                headerStyle={{ background: "lightblue" }}
                                allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                            />
                        </Paper>
                    </React.Fragment>
                    :
                    <Bar
                        data={this.state.chartData}
                        width={400}
                        height={300}
                        options={options}
                        redraw
                    />}
            </div>
        )};
}

CorrectiveActions.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    onChanged: PropTypes.func.isRequired,
}
export default CorrectiveActions;
